<template>
  <div v-if="propData.data && propData.data.length > 0"
       class="container">
    <div class="row">
      <div class="col">
        <b-form-checkbox
          :id="`selecionar_todos_registros_${ _uid }`"
          v-model="selecionar_todos"
          :name="`selecionar_todos_registros_${ _uid }`"
          :value="true"
          :unchecked-value="false">
          Selecionar todos
        </b-form-checkbox>
      </div>
      <div class="col text-right">
        <Pagination :page="pagination.page"
                    :last-page="pagination.lastPage"
                    @onPreviousPage="changePage(pagination.page - 1)"
                    @onNextPage="changePage(pagination.page + 1)" />
      </div>
      <div class="col-7">
        <div class="row no-gutters">
          <div class="col-5">
            <div class="row no-gutters text-right">
              <div class="col text-right mr-2">
                <label class="label">
                  Mostrar:
                </label>
              </div>
              <div class="col-3">
                <!--<v-select v-model="filtros.quantidade"
                          :options="[20, 30, 50]"
                          class="form-control form-control-sm" />-->
                <select v-model="pagination.perPage"
                        class="form-control form-control-sm"
                        @change="changePage()">
                  <option v-for="(value, index) in [20, 30, 50]"
                          :key="`valor_quantidade_${ _uid }_${ index }`">
                    {{ value }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-7">
            <div class="row no-gutters">
              <div class="col text-right mr-2">
                <label class="label">
                  Ordenar por:
                </label>
              </div>
              <div class="col-6">
                <!--<v-select v-model="filtros.ordenacao"
                          :options="['Data inclusão', 'Data Registro', 'Data Cumprimento']"
                          class="form-control form-control-sm" />-->
                <select v-model="filtros.ordenacao"
                        class="form-control form-control-sm"
                        @change="changePage()">
                  <option v-for="(order, index) in selects.order"
                          :key="`valor_ordenacao_${ _uid }_${ index }`"
                          :value="order.value">
                    {{ order.label }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col">
        <gerenciador-resultados-item v-if="propData"
                                     :prop-resultados="propData.data"
                                     :prop-selecionar-todos="selecionar_todos"
                                     @onCumprirTodos="$emit('onCumprirTodos')" />
      </div>
    </div>
  </div>
</template>

<script>
  /* components */
  import GerenciadorResultadosItem from "@/components/SofiaRei/Gerenciador/GerenciadorResultados/GerenciadorResultadosItem"
  import Pagination from "@/components/SofiaRei/Pagination"

  export default {
    name: "GerenciadorResultados",
    components: {
      GerenciadorResultadosItem,
      Pagination
    },
    props: {
      propData: {
        type: Object,
        default: () => ([])
      }
    },
    data () {
      return {
        selects: {
          order: [
            { label: 'Data Inclusão', value: 'data_inclusao' }, { label: 'Data Registro', value: 'data_registro' }, { label: 'Data Cumprimento', value: 'data_cumprimento' }
          ]
        },
        selecionar_todos: false,
        filtros: {
          ordenacao: 'data_inclusao'
        },
        pagination: {
          page: 0,
          lastPage: 0,
          perPage: 20
        }
      }
    },
    watch: {
      propData () {
        this.pagination.page = this.propData.page
        this.pagination.lastPage = this.propData.lastPage
      }
    },
    methods: {
      changePage (page = 1) {
        this.pagination.page = page
        this.$emit('onChangePage', this.pagination, this.filtros.ordenacao)
      }
    }
  }
</script>

<style scoped>

</style>
